import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    login: {
        token: null,
        loggedIn: false,
    },
};

const AuthSlice = createSlice({
    name: 'AuthReducer',
    initialState,
    reducers: {
        loginSuccess: (state, action) => {
            state.login.token = action.payload.token;
            state.login.loggedIn = true;
        },
        logoutSuccess: (state) => {
            state.login.token = null;
            state.login.loggedIn = false;
        },
        updateTokenSuccess: (state, action) => {
            state.login.token = action.payload.newToken;
        },
    },
});

export const { loginSuccess, logoutSuccess, updateTokenSuccess } = AuthSlice.actions;
export default AuthSlice.reducer;
